export default __webpack_public_path__ + "static/media/tables_fetures_image.a37e7ae2.png";